/**
 * Copy a string to the clipboard.
 *
 * Uses the Clipboard API when available, falling back to a hidden textarea +
 * execCommand for non-secure contexts (e.g. http://localhost on older browsers).
 *
 * Throws when both paths fail — callers should catch to show an error toast.
 */
export async function copyTextToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return;
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    if (!ok) throw new Error("execCommand copy failed");
  }
}
